import styles from "./ModalContrapartida.module.css";
import Button from "../../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../../components/Grid";
import { Table } from "../../../../../../components/Table";

const columnsProdutos = [
  {
    column: "Produto",
  },
  {
    column: "Qtde.",
  },
  {
    column: "Total Litros",
  },
  {
    column: "Brinde.",
  },
];

export default function ModalContrapartida({ closeModal, contrapartida }) {
  return (
    <div className={styles.modal_container}>
      {contrapartida && (
        <Grid>
          <Col size={12}>
            <Table columns={columnsProdutos} title="Produtos">
              {contrapartida.map((item, index) => (
                <tr key={index}>
                  <td> {item?.Brinde} </td>
                  <td> {item?.QuantidadeSolicitada} </td>
                  <td> {item?.VolumeTotal} </td>
                  <td>{item?.Bonificacao ? "Com Brinde" : "Sem Brinde"}</td>
                </tr>
              ))}
            </Table>
            {contrapartida.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "12px",
                }}
              >
                Nenhuma contrapartida adicionada
              </div>
            ) : (
              ""
            )}
          </Col>
        </Grid>
      )}

      <div className={styles.buttons_container}>
        <Button
          title="Fechar"
          type="button"
          onClick={() => closeModal()}
          color={"secondary"}
          className={styles.button_sm}
        />
      </div>
    </div>
  );
}
